import React from 'react';
import { PropTypes as RPT } from 'prop-types';

import Field from './Field.react';

export default class Filter extends React.Component {
  static propTypes = {
    activateField: RPT.func,
    getFieldName: RPT.func,
    activeField: RPT.string,
    dataByFields: RPT.object,
    localization: RPT.object,
    searchTerm: RPT.string,
    searchTermChanged: RPT.func,
  }

  render() {
    const {
      activateField,
      activeField,
      dataByFields,
      getFieldName,
      localization,
      searchTerm,
      searchTermChanged,
    } = this.props;

    let result;
    if (dataByFields === null) {
      result = (<p>{localization.loading}</p>);
    } else if (Object.keys(dataByFields).length === 0) {
      result = (<p>{localization.not_found}</p>);
    } else {
      result = Object.keys(dataByFields).sort((fieldA, fieldB) => {
        const titleA = getFieldName(fieldA).toUpperCase();
        const titleB = getFieldName(fieldB).toUpperCase();
        return titleA.localeCompare(titleB);
      })
        .map(field => (
        <Field
          key={field}
          activeField={activeField}
          activateField={activateField}
          field={getFieldName(field)}
          fieldId={field}
          count={(dataByFields[field] || []).length}
        />
        ));
    }

    return (
      <div className="filter with-textfield dictionary-terms">
        <form className="form-filter">
          <div className="inner">
            <div className="search-items">
              <div className="fakeinput-reset form-control">
                <div className="form-group string required terms_filter_query">
                  <input
                    className="form-control string required form-control textfield"
                    placeholder={localization.search_term_placeholder}
                    type="text"
                    id="terms_filter_query"
                    onChange={searchTermChanged}
                    value={searchTerm || ''}
                  />
                </div>
              </div>
            </div>
            <div className="form-group radio_buttons required terms_filter_field_id">
              {result}
            </div>
          </div>
        </form>
      </div>

    );
  }
}
